import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MaskedInput from 'react-text-mask';
import DayPickerInput from 'react-day-picker/DayPickerInput'
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import { omit } from 'lodash';

/**
 * Form layout
 */

export const FormGroupHeader = (props) => {
    return (
        <div className="form-group-header">
            {props.children}
        </div>
    );
}

export const FormGroupBody = (props) => {
    return (
        <div className="form-group-body">
            {props.children}
        </div>
    );
}

/**
 * Text input
 * @param {any} props
 */
export class Input extends React.Component {
    static propTypes = {
        // Property in parent's state object to update
        model: PropTypes.string,
        isRequired: PropTypes.bool,
        // Property in state[model] to update
        name: PropTypes.string,
        label: PropTypes.string,
        labelStyles: PropTypes.object,
        // Array of error message strings for this field
        errors: PropTypes.array,
        mask: PropTypes.array,
        datepicker: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        mask: null,
        datepicker: false
    };

    constructor(props) {
        super(props);
    }

    render() {
        let classes = cx(this.props.className, {
            'error-state': this.props.errors && this.props.errors.length > 0
        });

        let newProps = {...this.props, 
            className: classes,
            onChange: this.props.datepicker ? this.props.onChange : this.handleChange,
            datepicker: this.props.datepicker.toString()
        };

        let BaseInputComponent = (<input {...omit(newProps, ['isRequired', 'labelStyles'])} />);
        if (this.props.mask) { BaseInputComponent = (<MaskedInput {...omit(newProps, ['labelStyles'])} />); }
        if (this.props.datepicker) { BaseInputComponent = (<DatePicker {...omit(newProps,["label", "labelStyles"])} />); }
        
        return (
            <span>
                {this.props.renderLabel &&
                    this.props.renderLabel()
                }
                {this.props.label &&
                    <label style={this.props.labelStyles || {}}>
                        {this.props.label}
                        {this.props.isRequired &&
                            <span className="required">*</span>
                        }
                    </label>
                }
                {BaseInputComponent}
                {(this.props.errors && this.props.errors.length > 0) &&
                    <FieldError messages={this.props.errors} />
                }
            </span>
        );
    }

    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.model, e.target.name, e.target.value, e);
        }
    }
};
export class DatePicker extends React.Component {
    static propTypes = {
        // Property in parent's state object to update
        model: PropTypes.string,

        // Property in state[model] to update
        name: PropTypes.string,
        label: PropTypes.string,
        errors: PropTypes.array,
        mask: PropTypes.array,
        onChange: PropTypes.func
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        let classes = cx(this.props.className, {
            'error-state': this.props.errors && this.props.errors.length > 0
        });

        let newProps = {...this.props, 
            className: classes,
            onDayChange: this.handleChange,
            format: 'MM/DD/YYYY',
            datepicker: this.props.datepicker ? this.props.datepicker.toString() : null
        };

        return (
            <span>
                {this.props.label && <label>{this.props.label}</label>}
                <DayPickerInput
                    {...newProps}
                />
                {(this.props.errors && this.props.errors.length > 0) &&
                    <FieldError messages={this.props.errors} />
                }
            </span>
        );
    }

    handleChange = (day) => {
        if (this.props.onChange) {
            let value = ''
            if (day != null) {
                value = moment(day).format('MM/DD/YYYY');
            }
            
            this.props.onChange(this.props.model, this.props.name, value);
        }
    }
};

export const DateTimePicker = (props)=>{
    const {name, onChange, model, outputFormat, value} = props;
    const onComponentChange = (date)=>{
        if(onChange){
            let value = outputFormat == null ? date : date.format(outputFormat);
            onChange(model,name,value);
        }
    }

    //convert to the right value
    let safeValue = typeof(value) === 'string' ? moment(value) : value;
    return (<Datetime
        utc={false}
        inputProps={{autoComplete:"none"}}
        {...props}
        value={safeValue}
        className=""
        onChange={onComponentChange}
    />)

};

export class TextArea extends React.Component {

    static propTypes = {
        // Property in parent's state object to update
        model: PropTypes.string,

        // Property in state[model] to update
        name: PropTypes.string,
        label: PropTypes.string,
        labelStyles: PropTypes.object,
        errors: PropTypes.array,

        onChange: PropTypes.func
    }

    constructor(props) {
        super(props);
    }

    render() {
        let classes = cx(this.props.className, {
            'error-state': this.props.errors && this.props.errors.length > 0
        });

        let newProps = {...this.props, 
            className: classes,
            onChange: this.handleChange
        };

        return (
            <span>
                {this.props.label && <label style={this.props.labelStyles}>{this.props.label}</label>}
                {this.props.isRequired &&
                    <span className="required">*</span>
                }
                <textarea onChange={this.handleChange} {...omit(newProps, ['labelStyles'])}></textarea>
                {(this.props.errors && this.props.errors.length > 0) &&
                    <FieldError messages={this.props.errors} />
                }
            </span>
        );
    }

    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.model, e.target.name, e.target.value);
        }
    }
}

export class Select extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let classes = cx(this.props.className, {
            'error-state': this.props.errors && this.props.errors.length > 0
        });

        let newProps = {...this.props, 
            className: classes
        };

        return (
            <div className={cx({'d-inline-block':this.props.isInline})}>
                {this.props.label &&
                    <label>
                        {this.props.label}
                        {this.props.isRequired &&
                            <span className="required">*</span>}
                    </label>}
                <select name={this.props.name} className={classes} value={this.props.value} onChange={this.handleChange} disabled={this.props.readOnly}>
                    {this.props.children}
                </select>
                {(this.props.errors && this.props.errors.length > 0) &&
                    <FieldError messages={this.props.errors} />
                }
            </div>
        );
    }

    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.model, e.target.name, e.target.value);
        }
    }
}

export const FieldError = (props) => {
    return (
        <div className="error-helpmessage">
            {props.messages.map((message) => {
                return <span key={message}>{message}</span>
            })}
        </div>
    );
}

export class PhoneNumberInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <input
                type="text"
                className="form-control"
                value={this.props.value}
                placeholder={this.props.placeHolder}
                onChange={this.onChange}
                readOnly={this.props.isDisabled}
            />
        );
    }

    onChange = (e) => {
        this.props.onChange(this.props.index, { [this.props.propertyName]: e.target.value });
    }
};

PhoneNumberInput.defaultProps = {
    propertyName: 'PhoneNumber',
    placeHolder: 'Enter a Phone Number'
};

PhoneNumberInput.propTypes = {
    // Property name to return in JSON response when field changes
    propertyName: PropTypes.string,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func
};

export class ListBuilderInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <input
                type="text"
                className="form-control"
                value={this.props.value}
                placeholder={this.props.placeHolder}
                onChange={this.onChange}
                readOnly={this.props.isDisabled}
                style={this.props.style}
            />
        );
    }

    onChange = (e) => {
        this.props.onChange(this.props.index, { [this.props.propertyName]: e.target.value });
    }
}

ListBuilderInput.defaultProps = {
    propertyName: 'PhoneNumber',
    placeHolder: 'Enter a Phone Number'
};

ListBuilderInput.propTypes = {
    // Property name to return in JSON response when field changes
    propertyName: PropTypes.string,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    style: PropTypes.object
};


export const StateSelect = (props) => {
    let options = [
        { value: -1, label: 'Select a State' },
        { value: 'AK', label: 'AK' },
        { value: 'AL', label: 'AL' },
        { value: 'AZ', label: 'AZ' },
        { value: 'AR', label: 'AR' },
        { value: 'CA', label: 'CA' },
        { value: 'CO', label: 'CO' },
        { value: 'CT', label: 'CT' },
        { value: 'DC', label: 'DC' },
        { value: 'DE', label: 'DE' },
        { value: 'FL', label: 'FL' },
        { value: 'GA', label: 'GA' },
        { value: 'HI', label: 'HI' },
        { value: 'ID', label: 'ID' },
        { value: 'IL', label: 'IL' },
        { value: 'IN', label: 'IN' },
        { value: 'IA', label: 'IA' },
        { value: 'KS', label: 'KS' },
        { value: 'KY', label: 'KY' },
        { value: 'LA', label: 'LA' },
        { value: 'ME', label: 'ME' },
        { value: 'MD', label: 'MD' },
        { value: 'MA', label: 'MA' },
        { value: 'MI', label: 'MI' },
        { value: 'MN', label: 'MN' },
        { value: 'MS', label: 'MS' },
        { value: 'MO', label: 'MO' },
        { value: 'MT', label: 'MT' },
        { value: 'NE', label: 'NE' },
        { value: 'NV', label: 'NV' },
        { value: 'NH', label: 'NH' },
        { value: 'NJ', label: 'NJ' },
        { value: 'NM', label: 'NM' },
        { value: 'NY', label: 'NY' },
        { value: 'NC', label: 'NC' },
        { value: 'ND', label: 'ND' },
        { value: 'OH', label: 'OH' },
        { value: 'OK', label: 'OK' },
        { value: 'OR', label: 'OR' },
        { value: 'PA', label: 'PA' },
        { value: 'RI', label: 'RI' },
        { value: 'SC', label: 'SC' },
        { value: 'SD', label: 'SD' },
        { value: 'TN', label: 'TN' },
        { value: 'TX', label: 'TX' },
        { value: 'UT', label: 'UT' },
        { value: 'VT', label: 'VT' },
        { value: 'VA', label: 'VA' },
        { value: 'WA', label: 'WA' },
        { value: 'WV', label: 'WV' },
        { value: 'WI', label: 'WI' },
        { value: 'WY', label: 'WY' }
    ];

    // Filter out excluded states if excludedStates prop is provided
    if (props.excludedStates && props.excludedStates.length > 0) {
        const excludedArray = props.excludedStates.split(',').map(s => s.trim());
        options = options.filter(opt => opt.value === -1 || !excludedArray.includes(opt.value));
    }

    return (
        <Select {...props}>
            {options.map((option) => {
                if (!props.panelExcludeStateCSV || !props.panelExcludeStateCSV.includes(option.label)) {
                    return <option key={option.value} value={option.value}>{option.label}</option>
                }
            })}
        </Select>
    );
}


/*************************************
 * ToggledInput
 *************************************/
export class ToggledInput extends React.Component {
    static defaultProps = {
        editable: false,
        classNameStatic: "h4 mt-0",
        classNameWrapper: "mb-3"
    };
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.editable) {
            return (
                <div className={this.props.classNameWrapper}>
                    <Input {...omit(this.props, ["classNameStatic", "classNameWrapper","editable"])} />
                </div>);
        }
        else {
            return (
                <div className={this.props.classNameWrapper}>
                    {this.props.label &&
                        <label>
                            {this.props.label}
                            {this.props.isRequired &&
                                <span className="required">*</span>
                            }
                        </label>
                    }
                    <div className={this.props.classNameStatic}>{this.props.value}</div>
                </div>);
        }

    }
}
/*************************************
 * ToggledTextArea
 *************************************/
export class ToggledTextArea extends React.Component {
    static defaultProps = {
        editable: false,
        classNameStatic: "h4 mt-0",
        classNameWrapper: "mb-3"
    };
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.editable) {
            return (
                <div className={this.props.classNameWrapper}>
                    <TextArea {...omit(this.props, ["classNameStatic", "classNameWrapper", "editable"])} />
                </div>);
        }
        else {
            return (
                <div className={this.props.classNameWrapper}>
                    {this.props.label &&
                        <label>
                            {this.props.label}
                            {this.props.isRequired &&
                                <span className="required">*</span>
                            }
                        </label>
                    }
                    <div className={this.props.classNameStatic}>{this.props.value}</div>
                </div>);
        }

    }
}

/*************************************
 * ToggledSelect
 *************************************/
export class ToggledSelect extends React.Component {
    static defaultProps = {
        editable: false,
        classNameStatic: "h4 mt-0 mb-4",
        classNameWrapper: "mb-3"
    };
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.editable) {
            return (
                <div className={this.props.classNameWrapper}>
                    <Select {...omit(this.props, ["classNameWrapper", "classNameStatic", "editable"])} />
                </div>
            );
        }
        else {
            return (
                <div className={this.props.classNameWrapper}>
                    {this.props.label &&
                        <label>
                            {this.props.label}
                            {this.props.isRequired &&
                                <span className="required">*</span>
                            }
                        </label>
                    }
                    <div className={this.props.classNameStatic}>{this.props.displayValue}</div>
                </div>);
        }

    }
}

/*************************************
 * ToggledEditGroup
 *************************************/
export class ToggledEditGroup extends React.Component {
    static defaultProps = {
        editable: false,
        iconEdit: "fa fa-2x fa-pencil-square-o",
        iconDone: "fa fa-2x fa-check",
        lockdown: false,
        onToggle: () => { },
        title: "",
        statusText: "",
        classNameTitle: "h3 mt-0"
    };
    constructor(props) {
        super(props);
    }
    render() {
        let icon = this.props.editable ? this.props.iconDone : this.props.iconEdit;
        return (
            <div className={this.props.className}>
                {!this.props.lockdown &&
                    <div className="row">
                        <div className={cx("col-sm-8", this.props.classNameTitle)}>{this.props.title}</div>
                        <div className="col-sm-3 text-right">{this.props.statusText}</div>
                        <div className="col-sm-1 text-right" ><a onClick={this.props.onToggle}><i className={icon}></i></a></div>
                    </div>
                }
                <div>
                    {this.props.children}
                </div>
            </div>);
    }
}

/**
* A reusable input component with a floating label effect, similar to Material-UI.
* The label floats up inside the input field when focused or contains a value.
*
* @param {object} props - The component props.
* @param {string} props.label - The text for the input's label.
* @param {string} props.value - The current value of the input.
* @param {function} props.onChange - The callback function to handle value changes.
* @param {string} [props.type='text'] - The type of the input element (e.g., 'text', 'email', 'password').
*/
export function FloatingLabelInput({
    label,
    value,
    onChange,
    tabIndex,
    disabled,
    errors = {},
    mask = false,
    datepicker = false,
    type = 'text'
}) {
    const [isFocused, setIsFocused] = useState(false);
    const [currentType, setCurrentType] = useState(type);

    useEffect(() => {
        if (type === 'time') {
            if (isFocused) {
                setCurrentType('time');
            } else if (!value) {
                setCurrentType('text');
            }
        }
    }, [isFocused, value, type]);

    const isFloated = isFocused || Boolean(value);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    const containerClasses = `floating-input-container ${isFocused ? 'focused' : ''}`;
    const labelClasses = `floating-label ${isFloated ? 'floated' : ''}`;
    const inputClasses = cx('floating-input', {
        'error-state': errors && errors.length > 0
    });

    let BaseInputComponent = (<input
        id={label}
        type={currentType}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        tabIndex={tabIndex}
        disabled={disabled}
        className={inputClasses} />);

    if (mask) {
        BaseInputComponent = (<MaskedInput
            id={label}
            type={currentType}
            value={value}
            tabIndex={tabIndex}
            disabled={disabled}
            mask={mask}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            className={inputClasses} />); }

    if (datepicker) {
        BaseInputComponent = (<DayPickerInput
            id={label}
            type={currentType}
            value={value}
            tabIndex={tabIndex}
            disabled={disabled}
            onChange={(e) => {
                onChange(e.target.value);
            }}
            onFocus={handleFocus}
            onBlur={handleBlur}
            format={'MM/DD/YYYY'}
            classNames={{
                container: 'floated-DayPickerInput',
                overlayWrapper: 'DayPickerInput-OverlayWrapper',
                overlay: 'DayPickerInput-Overlay'
            }}
            onDayChange={(day) => {
                if (onChange) {
                    let value = ''
                    if (day != null) {
                        value = moment(day).format('MM/DD/YYYY');
                    }

                    onChange(value);
                }
            }}
            className={inputClasses} />);
    }

    return (
        <div className={containerClasses}>
            <label htmlFor={label} className={labelClasses}>
                {label}
            </label>
            {BaseInputComponent}

            {(errors && errors.length > 0) &&
                <FieldError messages={errors} />
            }
        </div>
    );
}